import { SVGProps } from 'react';

const CarTaxiFront = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 2h4m7 6-2 2m0 0-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10m14 0H5m14 0a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2M5 10 3 8m2 2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2m2-4h.01M17 14h.01M19 18H5m14 0v2M5 18v2"
    />
  </svg>
);
export default CarTaxiFront;
